module.exports = __webpack_public_path__ + "img/upload.b39b701c.svg";